import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const NoBusinessAvailable: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
      <Typography variant="h5" color="text.secondary" gutterBottom>
        Você não é administrador de nenhum estabelecimento.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/home')}>
        Ir para o Dashboard
      </Button>
    </Box>
  );
};
